export default __webpack_public_path__ + "static/media/walkthrough.b1ea9e62.png";